import { Component, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { PersonstammSucheZpvComponent } from './suche-zpv/personstamm-suche-zpv.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-personstamm-suche',
  templateUrl: './personstamm-suche.component.html',
  styleUrls: ['./personstamm-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    PersonstammSucheZpvComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class PersonstammSucheComponent implements OnInit {
  searchMode;

  constructor(private personstammStateService: SearchStateService) {
    keysToTranslate<string>(['personstamm.SucheTitel', 'personstamm.search.breadcrumb']);
  }

  ngOnInit() {
    this.searchMode = this.personstammStateService.lastSearchMode || SearchMode.searchZpv;
  }

  searchZpv(): string {
    return SearchMode.searchZpv;
  }
}
